import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchProjectDetail } from 'api/project.service';
import { initialProjectDetailValue } from 'redux/initial-state';
import { ProjectDetailResponse } from 'types/entity';

export const PROJECT_DETAIL_READ_STORE_NAME = 'projectDetailRead';

export const loadProjectDetail = createAsyncThunk(
  `${PROJECT_DETAIL_READ_STORE_NAME}/load`,
  async (selectedProjectId: string) => {
    const response = await fetchProjectDetail(selectedProjectId);
    return response;
  },
);

export type ProjectDetailReadState = {
    loaded: boolean
    entity: ProjectDetailResponse
    error: any
}

export const initialProjectDetailReadState: ProjectDetailReadState = {
  entity: initialProjectDetailValue,
  loaded: false,
  error: null,
};

export const projectDetailReadSlice = createSlice({
  name: PROJECT_DETAIL_READ_STORE_NAME,
  initialState: initialProjectDetailReadState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadProjectDetail.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(loadProjectDetail.fulfilled, (state, action) => {
      state.entity = action.payload;
      state.loaded = true;
    });
    builder.addCase(loadProjectDetail.rejected, (state, action) => {
      state.error = action.payload;
      state.loaded = true;
    });
  },
});

export const projectDetailReadAction = {
  ...projectDetailReadSlice.actions,
  loadProjectDetail,
};

export default projectDetailReadSlice.reducer;
